<template>
    <div class="mt-3 grid grid-cols-1 row-gap-2 col-gap-4 sm:grid-cols-12">
        <h2 class="w-full col-span-12 pb-2 border-b-2 border-charcoal-900 text-left font-medium text-charcoal-900">
            Activity
        </h2>
        <table class="w-full mb-1 items-table col-span-12">
            <thead>
                <tr>
                    <th class="table-head-cell text-center">Status #</th>
                    <th class="table-head-cell text-center">Type</th>
                    <th class="table-head-cell text-center">Actioned By</th>
                    <th class="table-head-cell text-center">Status From</th>
                    <th class="table-head-cell text-center">Status To</th>
                    <th class="table-head-cell text-center">Actioned Date</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(activity, index) in orderedActivity" :key="index">
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.ordering }}</td>
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.meta && activity.meta.type ? activity.meta.type : '' }}</td>
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.actioned_by }}</td>
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.status_from }}</td>
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.status_to }}</td>
                    <td class="px-2 py-2 border-b border-gray-400 text-gray-800 align-middle text-center text-xs">{{ activity.created_at | moment("DD/MM/YYYY h:mm a") }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "Activity",
        props: {
            activity: { type: Array, default: () => [], required: false }
        },
        data: function () {
            return {

            }
        },
        computed: {
            orderedActivity(){
                return this.activity.slice().sort((a, b) => a.ordering - b.ordering);
            }
        }
    }
</script>

<style scoped>
    #tasks div:last-child .task-container {
        border: 0!important;
    }
</style>
